import { useBlocksConfig } from "@pathwright/blocks-engine"
import { Content } from "@pathwright/ui/src/components/content/Content"
import { motion } from "framer-motion"
import get from "lodash/get"
import Feedback from "../../block/BlockFeedback/view"
import BlockSubmit from "../../block/BlockSubmit"
import Matching from "./Matching/view"
import MultipleChoice from "./MultipleChoice/view"
import Paragraph from "./Paragraph/view"
import QuestionHeader from "./QuestionHeader"
import { QuestionContainer } from "./ui"

const QuestionView = (props) => {
  const { blockStyles, data, layout, onChange } = props

  const { hideAssessmentFeedback } = useBlocksConfig()

  const isSubmitted = get(data, "answer.hasSubmitted", false)

  const renderQuestion = () => {
    switch (layout) {
      case "multipleChoice":
        return <MultipleChoice {...props} />
      case "checkBoxes":
        return <MultipleChoice {...props} />
      case "matching":
        return <Matching {...props} />
      default:
        return <Paragraph {...props} />
    }
  }

  const renderFeedback = () => {
    return isSubmitted ? (
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        style={{ position: "relative" }}
      >
        <Feedback feedbackList={data.feedback} />
      </motion.div>
    ) : null
  }

  const handleSubmit = () => {
    const submission = {
      answer: {
        ...(data.answer || {}),
        hasSubmitted: true,
        answeredDate: new Date().getTime()
      }
    }
    onChange({ ...submission }, true)
  }

  const handleUnsubmit = () => {
    const unsubmission = {
      answer: {
        ...(data.answer || {}),
        hasSubmitted: false,
        answeredDate: null
      }
    }
    onChange({ ...unsubmission }, true)
  }

  return (
    <Content.Container
      style={{ maxHeight: "100%" }} // prevent preview from looking wonky
      flexForPrint={true}
      className="QuestionView"
    >
      <QuestionContainer blockStyles={blockStyles}>
        <div style={{ width: "100%", marginBottom: "1rem" }}>
          <QuestionHeader {...props} />
          {renderQuestion()}
        </div>
        {!hideAssessmentFeedback && renderFeedback()}
        <footer>
          <BlockSubmit
            onSubmit={handleSubmit}
            onUnsubmit={handleUnsubmit}
            isSubmitted={isSubmitted}
            answeredDate={get(data, "answer.answeredDate", null)}
          />
        </footer>
      </QuestionContainer>
    </Content.Container>
  )
}

export default QuestionView
